import React from 'react'

import {
  Button,
  Checkbox,
  FormControlLabel,
  Grow,
  Link,
  Paper,
  Typography,
  withStyles
} from '@material-ui/core'

import httpService from '@services/httpService'
import Terms from '@images/terms/terms.svg'
import Sign from '@images/terms/sign.svg'
import { useSessionData } from '@contexts/SessionDataProvider'

const TermsOfUse = ({ classes, handleError, term, o }) => {
  const sessionData = useSessionData()
  const { currentUser } = sessionData

  const [state, setState] = React.useState({
    accept_terms: false
  })

  const handleChangeTerm = () => {
    setState({
      accept_terms: !state.accept_terms
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    try {
      const path = o ? `/v4/o/${o}/user_terms/sign_term` : `/v4/user_terms/sign_term`
      const { data } = await httpService.post(path, { term_id: term.id, signed: state.accept_terms })
      Turbolinks.visit(data.url || `/v4`)
    }
    catch (error) {
      handleError(error)
    }
  }

  return (
    <form className={classes.UserTerms_form} onSubmit={handleSubmit}>
      <Paper className={classes.UserTerms_wrapper} elevation={0}>
        <header className={classes.UserTemrs_title}>
          <Typography variant='body2'>
            {I18n.t('v4/terms.updated.hello', {name: currentUser.name})}
          </Typography>
          <Typography variant='body2'>
            {I18n.t('v4/terms.updated.title')}
          </Typography>
        </header>

        <main className={classes.UserTems_main}>
          <div className={classes.UserTerms_imageWrapper}>
            <div className={classes.UserTerms_image}>
              <img src={Terms} />
              <Grow in={state.accept_terms}>
                <img src={Sign} className={classes.UserTerms_sign} />
              </Grow>
            </div>
          </div>

          <Typography variant='body2' className={classes.UserTerms_text}>
            <Link
              variant="body2"
              href='/v5/terms'
              className={classes.UserTerms_link}
              underline='always'
              target='_blank'
            >
              {I18n.t('v4/terms.updated.click_here')}
            </Link>
            {` ${I18n.t('v4/terms.updated.complete_terms')}`}
          </Typography>

          <div>
            <FormControlLabel
              control={
                <Checkbox
                  checked={state.accept_terms}
                  onChange={handleChangeTerm}
                  value='checked'
                  color='primary'
                />
              }
              label={I18n.t('v4/terms.updated.accept')}
              classes={{
                label: classes.UserTerms_text
              }}
            />
          </div>
        </main>

        <footer className={classes.UserTerms_actions}>
          <Button
            className={classes.UserTerms_action}
            disabled={!state.accept_terms}
            color='primary'
            type='submit'
            variant='contained'
            fullWidth
          >
            {I18n.t('actions.continue')}
          </Button>
        </footer>
      </Paper>
    </form>
  )
}

const styles = (theme) => ({
  UserTerms_form: {
    display: 'flex',
    marginTop: 67,
    alignItems: 'center',
    justifyContent: 'center'
  },
  UserTemrs_title: {
    textAlign: 'center'
  },
  UserTerms_imageWrapper: {
    textAlign: 'center',
    margin: `${theme.spacing.unit * 3}px 0`
  },
  UserTerms_image: {
    position: 'relative',
    display: 'inline-block'
  },
  UserTerms_text: {
    fontSize: 13,
    fontWeight: 400
  },
  UserTerms_link: {
    color: theme.palette.text.primary,
    fontSize: 13,
    fontWeight: 500
  },
  UserTerms_sign: {
    position: 'absolute',
    bottom: 38,
    right: 27
  },
  UserTerms_actions: {
    marginTop: theme.spacing.unit * 2
  }
})

export default withStyles(styles)(TermsOfUse)
